import { useState } from "react";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from ".";
import {
  changPassword,
  createAccount,
  deleteAccount,
  getListAccount,
  getProfileUser,
  statisticData,
  listTransInDay,
  getActivitiesData,
  createCashFlowSlice,
  getListCashFlowSlice,
  cancelCashFlowSlice
} from "../store/slices/accountSlice";

const voucherTypes = [
  { label: "Chi khác", id: 1, value: 1, key: 1, dataValue: "C-0" },
  { label: "Trả lương", id: 2, value: 2, key: 2, dataValue: "C-1" },
  { label: "Trả lãi", id: 3, value: 3, key: 3, dataValue: "C-2" },
  { label: "Chi tiêu dùng", id: 4, value: 4, key: 4, dataValue: "C-3" },
  { label: "Chi trả quỹ", id: 5, value: 5, key: 5, dataValue: "C-4" },
  { label: "Tạm ứng", id: 6, value: 6, key: 6, dataValue: "C-5" },
  { label: "Hoa hồng", id: 7, value: 7, key: 7, dataValue: "C-6" },
  { label: "Chi vé hoặc văn phòng", id: 7, value: 8, key: 8, dataValue: "C-7" },
  { label: "Chi mua xe", id: 9, value: 9, key: 9, dataValue: "C-8" },
  { label: "Chi Dọn xe - Hồ sơ", id: 10, value: 10, key: 10, dataValue: "C-9" },
  { label: "Chi Tiền Nhà", id: 11, value: 11, key: 11, dataValue: "C-10" },
  { label: "Chi mượn tiền", id: 12, value: 12, key: 12, dataValue: "C-11" },
  { label: "Thu khác", id: 13, value: 13, key: 13, dataValue: "T-0" },
  { label: "Thu trả quỹ", id: 14, value: 14, key: 14, dataValue: "T-1" },
  { label: "Thu tiền nợ", id: 15, value: 15, key: 15, dataValue: "T-2" },
  { label: "Thu tiền ứng", id: 16, value: 16, key: 16, dataValue: "T-3" },
  { label: "Thu tiền phạt", id: 17, value: 17, key: 17, dataValue: "T-4" },
  { label: "Thu hoa hồng", id: 18, value: 18, key: 18, dataValue: "T-5" },
  {
    label: "Thu tiền vé hoặc văn phòng",
    id: 19,
    value: 19,
    key: 19,
    dataValue: "T-6"
  },
  { label: "Bán xe", id: 20, value: 20, key: 20, dataValue: "T-7" },
  { label: "Thu hồ sơ", id: 21, value: 21, key: 21, dataValue: "T-8" },
  { label: "Thu lãi khác", id: 22, value: 22, key: 22, dataValue: "T-9" }
];
const useAccount = () => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openOut, setOpenOut] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [deleteModalContent, setDeleteModalContent] = useState("");
  const {
    list,
    current,
    profile,
    statistic,
    activities,
    activitiesMetaData,
    listTranDayHistory,
    listCashFlow
  } = useAppSelector(state => state.account);
  const dispatch = useAppDispatch();
  const handleClose = () => {
    setOpen(false);
  };
  const handleOutClose = () => {
    setOpenOut(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleOpenOut = () => {
    setOpenOut(true);
  };
  const getList = async () => {
    setLoading(true);
    try {
      const res = await dispatch(getListAccount());
      return res.payload;
    } finally {
      setLoading(false);
    }
  };

  const getListTrans = async () => {
    setLoading(true);
    try {
      const res = await dispatch(listTransInDay());
      return res.payload;
    } finally {
      setLoading(false);
    }
  };

  const create = async data => {
    setLoading(true);
    try {
      const res = await dispatch(createAccount(data));
      return res.payload;
    } finally {
      setLoading(false);
    }
  };

  const useCreateCashFlow = async (creditData, actions) => {
    try {
      const { voucherType } = creditData;
      const tmp = voucherTypes.find(item => item.value === voucherType);
      creditData.voucherType = tmp.dataValue;
      const res = await dispatch(createCashFlowSlice(creditData));
      const success = !res.payload?.error;
      if (!success) {
        // actions.setErrors(errors);
        actions.setSubmitting(true);
        toast.error(res.payload?.error?.message);
      } else {
        setOpen(false);
        await dispatch(getListCashFlowSlice());
        toast.success("Tạo phiếu thu chi thành công");
      }
      actions.setSubmitting(false);
      Promise.resolve();
    } finally {
      // setOpen(false);
    }
  };
  const useGetListCashFlow = async () => {
    setLoading(true);
    try {
      await dispatch(getListCashFlowSlice());
    } finally {
      setLoading(false);
    }
  };

  const getProfile = async () => {
    setLoading(true);
    try {
      const res = await dispatch(getProfileUser());
      return res.payload;
    } finally {
      setLoading(false);
    }
  };

  const deleteProfile = async id => {
    setLoading(true);
    try {
      const res = await dispatch(deleteAccount(id));
      return res.payload;
    } finally {
      setLoading(false);
    }
  };

  const changePass = async data => {
    setLoading(true);
    try {
      const res = await dispatch(changPassword(data));
      return res.payload;
    } finally {
      setLoading(false);
    }
  };

  const getDashboard = async () => {
    setLoading(true);
    try {
      const res = await dispatch(statisticData());
      return res.payload;
    } finally {
      setLoading(false);
    }
  };
  const getActivities = async params => {
    setLoading(true);
    try {
      let newParams = "";
      if (params && Object.keys(params).length > 0) {
        newParams = new URLSearchParams(params);
        newParams = `?${newParams}`;
      }
      const res = await dispatch(getActivitiesData(newParams));
      return res.payload;
    } finally {
      setLoading(false);
    }
  };
  const handleOpenModalDelete = (content, id) => {
    setOpenModalDelete(true);
    setDeleteId(id);
    setDeleteModalContent(content);
  };

  const handleCloseModalDelete = () => {
    setOpenModalDelete(false);
  };

  const remove = async id => {
    if (!id) return;
    try {
      const res = await dispatch(cancelCashFlowSlice({ id }));
      const success = !res.payload?.errorid;
      if (!success) {
        toast.error(res.payload?.error?.message);
      } else {
        await dispatch(getListCashFlowSlice());
        toast.success("Hủy phiếu thành công");
      }
      Promise.resolve();
    } finally {
      setOpenModalDelete(false);
    }
  };
  return {
    list,
    profile,
    current,
    loading,
    getList,
    create,
    getProfile,
    deleteProfile,
    changePass,
    getDashboard,
    statistic,
    getListTrans,
    listTranDayHistory,
    getActivities,
    activities,
    activitiesMetaData,
    useCreateCashFlow,
    useGetListCashFlow,
    listCashFlow,
    open,
    openOut,
    handleClose,
    handleOutClose,
    handleOpen,
    handleOpenOut,
    handleOpenModalDelete,
    handleCloseModalDelete,
    openModalDelete,
    deleteId,
    deleteModalContent,
    remove
  };
};

export default useAccount;
